import styled, { css } from "styled-components";

export const MapAndAlertContainer = styled.div`
  margin-top: 30px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const MapTopAlert = styled.div`
  width: 100%;
  background-color: #2266ef;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.fontSize || "14px"};
  font-weight: 600;
  font-family: "Mona Sans", sans-serif;
  height: ${props => props.height || "48px"};
  border-radius: 8px;
`;

export const JobsMapContainer = styled.div`
  display: flex;
  width: 100%;
  height: 600px;
  gap: 0;
  border-radius: 8px;
  overflow: hidden;
`;

export const JobsMapMainArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const JobMarkerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const JobsInMapFilterContainer = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "230px 150px 57px 90px"};
  grid-column-gap: ${({ gap }) => gap || "30px"};
  align-items: center;
  justify-content: start;
  margin: 0;
  
  ${({ disableResponsive, responsiveBreakpoint }) =>
    !disableResponsive &&
    css`
      @media (max-width: ${responsiveBreakpoint || "412px"}) {
        display: flex;
        flex-wrap: wrap;
      }
    `}
`;
